// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__nyMAQ","topic":"Widget_topic__2rMBr","content":"Widget_content__2xAcD"};